import { useState } from "react";
import { apiPost, ApiError } from "../shared/api.js";
import { copy } from "../shared/copy.js";
import { Button } from "./Button.js";
import styles from "./DeleteMyData.module.css";

interface Props {
  passportId: string;
  refCode: string;
}

type Phase = "idle" | "confirm" | "sending" | "sent" | "no-email" | "error";

// Small anchor at the bottom of S4 that unfolds into a confirmation
// panel. Hitting "Прислать ссылку" posts to /api/passport/:id/delete-
// request; the backend emails a magic-link the parent must click. This
// component never mutates data directly — it just kicks off the email.
export function DeleteMyData(props: Props) {
  const [phase, setPhase] = useState<Phase>("idle");

  async function requestLink() {
    setPhase("sending");
    try {
      await apiPost(
        `/api/passport/${encodeURIComponent(props.passportId)}/delete-request`,
        { ref: props.refCode },
      );
      setPhase("sent");
    } catch (e) {
      if (e instanceof ApiError && e.code === "NO_EMAIL") {
        setPhase("no-email");
        return;
      }
      setPhase("error");
    }
  }

  return (
    <div className={styles.wrap}>
      {phase === "idle" && (
        <button
          type="button"
          className={styles.trigger}
          onClick={() => setPhase("confirm")}
        >
          {copy.gdpr.trigger}
        </button>
      )}

      {phase === "confirm" && (
        <div className={styles.dialog}>
          <p className={styles.dialogTitle}>{copy.gdpr.dialogTitle}</p>
          <p className={styles.dialogHint}>{copy.gdpr.dialogHint}</p>
          <div className={styles.row}>
            <Button variant="secondary" onClick={() => setPhase("idle")}>
              {copy.gdpr.dialogCancel}
            </Button>
            <Button block onClick={requestLink}>
              {copy.gdpr.dialogConfirm}
            </Button>
          </div>
        </div>
      )}

      {phase === "sending" && (
        <div className={styles.dialog}>
          <p className={styles.info}>{copy.common.loading}</p>
        </div>
      )}

      {phase === "sent" && (
        <div className={styles.dialog}>
          <p className={styles.info}>{copy.gdpr.sent}</p>
        </div>
      )}

      {phase === "no-email" && (
        <div className={styles.dialog}>
          <p className={styles.error}>{copy.gdpr.noEmail}</p>
          <Button variant="secondary" onClick={() => setPhase("idle")}>
            {copy.common.back}
          </Button>
        </div>
      )}

      {phase === "error" && (
        <div className={styles.dialog}>
          <p className={styles.error}>{copy.gdpr.genericError}</p>
          <Button variant="secondary" onClick={() => setPhase("idle")}>
            {copy.common.back}
          </Button>
        </div>
      )}
    </div>
  );
}
